<template>
  <div>
    <reward-customer-query v-show="action === 'query'" @change-action="changeAction" />
    <reward-customer-import v-if="action === 'batch'" :batch-num="batchNum" @change-action="changeAction" />
  </div>
</template>

<script>
import rewardCustomerImport from './reward-customer-import.vue'
import rewardCustomerQuery from './reward-customer-query.vue'
export default {
  components: {
    rewardCustomerImport,
    rewardCustomerQuery
  },
  data() {
    return {
      action: 'query',
      batchNum: ''
    }
  },
  created() {
    this. action = 'query'
  },
  methods: {
    changeAction(type, batchNum) {
      this.action = type
      this.batchNum = batchNum || ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/reward-policy/reward-customer.vue